import { apiServiceProxy } from './api-proxy';

import type { ApiServiceProxy } from './api-proxy';

export class LogService {
  constructor(private apiService: ApiServiceProxy) {}

  public logEvent(eventName: string) {
    return this.apiService.post('/log', { event_name: eventName });
  }
}

const logService = new LogService(apiServiceProxy);
export default logService;
